__turbopack_context__.v({
  "center": "ProductGridSection-module-scss-module__j9GhTa__center",
  "items": "ProductGridSection-module-scss-module__j9GhTa__items",
  "left": "ProductGridSection-module-scss-module__j9GhTa__left",
  "productGrid": "ProductGridSection-module-scss-module__j9GhTa__productGrid",
  "title": "ProductGridSection-module-scss-module__j9GhTa__title",
});
